<template>
  <div class="wrapper max30 ">
    <div>
      项目名称：
      <span style="position: relative">
      <Select class="input" v-model="projectFids" @on-change="checkAll" multiple>
        <Option value="all" >全部选择</Option>
        <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
      </Select>
        </span>
    </div>
    <Button type="primary" style="margin-left: 20px" @click="ok">确定</Button>
  </div>
</template>

<script>
  import { getProjects } from "api/common";

  export default {
    name: "projectList",
    data(){
      return {
        projectList:[],
        projectFids:[],
        selectedAll: true
      }
    },
    methods: {
      ok() {
        if (this.projectFids.length === 0) {
          this.$Message.info('所选项目为空')
          return
        }
        this.$emit('seach', this.projectFids)
      },
      getProjects() {
        getProjects().then(res => {
          if (!res.data) {
            return
          }
          this.projectList = res.data
          // if (this.projectList && this.projectList.length > 0) {
          //   const values = [];
          //   for (const property in this.projectList){
          //     values.push(this.projectList[property].value);
          //   }
          //   this.projectFids = values
          this.projectLists  = this.projectList.filter((ele)=>{
            return ele.isSelect === 1
          })
          this.projectLists.forEach(ele=>{
            this.projectFids.push(ele.value)
          })
          // }
          // this.$emit('seach', this.projectFids)
        }).catch(() => {
          return
        })
      },
      checkAll(){
        let isCheck = false;
        for (const property in this.projectFids){
          if(this.projectFids[property] === 'all'){
            isCheck = true
            this.selectedAll = !this.selectedAll
          }
        }
        if(isCheck && this.selectedAll){
          const values = [];
          for (const property in this.projectList){
            values.push(this.projectList[property].value);
          }
          this.projectFids = values
        }
        if(isCheck && !this.selectedAll){
          this.projectFids = []
        }
      }
    },
      created() {
        this.getProjects()
      }
  }
</script>

<style scoped>

  .input{
    display: inline-block;
    width: 300px;
    margin-right: 20px;
  }
  .wrapper{
    display: flex;
    align-items: center;
    /*justify-content: space-between;*/
  }
  .badge{
    position: absolute;
    top: -5px;
    right: -15px;
  }

</style>
